var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      { staticClass: "hkl-status-badge", class: _vm.color },
      _vm.$listeners
    ),
    [_vm._v("\n  " + _vm._s(_vm.value) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }